import { Button } from "@/components/ui/button";
import { cn, actionBackgroundColors } from "@/lib/utils";
import { ButtonStyleType, sectionVariants } from "@/types";
import Link from "next/link";

interface FooterCtaProps {
  darkMode?: boolean;
  variant?: sectionVariants;
  ctaBanner?: {
    title?: string;
    subtitle?: string;
    buttonText?: string;
    buttonLink?: string;
    buttonStyle?: ButtonStyleType;
  };
}

export const FooterCta = ({ ctaBanner, darkMode = true, variant = "A" }: FooterCtaProps) => {
  const ctaBannerClass = cn(
    "dark p-8 md:p-16 rounded-2xl text-center flex flex-col gap-10 mb-6 md:mb-16",
    actionBackgroundColors(darkMode, variant),
  );

  return (
    <div className="container">
      <div 
        className={ctaBannerClass} 
        // style={{
        // backgroundImage: `url(/cta-background-1.svg)`,
        //   backgroundSize: "cover",
        //   backgroundPosition: "center",
        //   backgroundRepeat: "no-repeat",
        // }}
      >
        {ctaBanner?.title && (
          <div className="max-w-[52ch] mx-auto">
            {/* <h2 className="text-gradient-primary">{ctaBanner?.title}</h2> */}
            <h2 className="text-primary">{ctaBanner?.title}</h2>
            {ctaBanner?.subtitle && (
              <p className="paragraph-lg text-gray-400 mt-4">{ctaBanner?.subtitle}</p>
            )}
          </div>
        )}
        {ctaBanner?.buttonText && (
          <div className="dark">
            <Button asChild variant="primary" size="lg" className="w-fit mx-auto">
              <Link href={ctaBanner?.buttonLink ?? "/"}>{ctaBanner?.buttonText}</Link>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};